import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-restore-password-page',
  templateUrl: './bmcore-restore-password-page.component.html',
  styleUrls: ['./bmcore-restore-password-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreRestorePasswordPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
